// TODO - Review file and move to common utils folder where suitable

function toReadableString (string: string): string {
    return string.replace(/([a-z])([A-Z])/g, '$1 $2').toLocaleLowerCase();
}

function capitaliseString (string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function toCamelCase (string: string): string {
    const splitString = string.split(' ');
    const camelCasedString = splitString.slice(1).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
    return splitString[0] + camelCasedString;
}

function toPascalCase (string: string): string {
    const splitString = string.split(' ');
    const pascalCasedString = splitString.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
    return pascalCasedString;
}

export function toSpacedPascalCase (value: string): string {
    return value.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export function truncateString (string: string, maxLength: number): string {
    if (string.length <= maxLength) return string;
    const lastSpaceIndex = string.lastIndexOf(' ', maxLength);
    const chosenIndex = lastSpaceIndex === -1 ? maxLength : lastSpaceIndex;
    return `${string.substring(0, chosenIndex)}...`;
}

export function getPlainTextFromHtmlString (value: string): string {
    if (!value) return '';
    const trimmed = value.trim();
    if (!trimmed.includes('<')) {
        return trimmed;
    }
    if (typeof document === 'undefined') {
        return trimmed
            .replace(/<[^>]*>/g, '')
            .replace(/\u00A0/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }
    const template = document.createElement('template');
    template.innerHTML = trimmed;
    return template.content.textContent
        ?.replace(/\u00A0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim() ?? '';
}

function toUKFormattedDate (string: string): string {
    return new Date(string).toLocaleDateString('en-uk');
}

function generateGuid ():string {
    function s4 (): string {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return `m${s4() + s4()}`;
}

function numberToCurrency (numberVal: number, maxDigits = 2): string {
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: maxDigits,
    }).format(numberVal);
}

export {
    capitaliseString,
    generateGuid,
    numberToCurrency,
    toCamelCase,
    toReadableString,
    toUKFormattedDate,
    toPascalCase,
};
